import { Component, Prop, Vue } from 'vue-property-decorator';
import LinkToAdder from './linkToAdder.vue';

@Component({ components: { LinkToAdder } })
export default class SuggestionsListViewerButtons extends Vue {
  @Prop() public suggestionsListId!: string;
}
